module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAiBAMAAADxDqeqAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTP///////////////////////////////////////48EzvsAAAAKdFJOUwAPsGrsFR67q1WzkCC6AAAAk0lEQVQ4y42TsQmAMBBFT8QBxA1sbLOCpLJzBKfIBukdQlBuSo1GhMA9/O0rHvn5J1KmEkwdGW8rYj1mxDox1sgY9AmD/sa2/sGmPmNLn3HWt2W6jB+92omMkx5w0hPWEfG+SF9m+NwO3q0aqBb12Nolps4ddh7wxzz+tyF+t+ZwawGX6nHntvi+MYc3FvBCG/mfE0SVvd9NxFCrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/arrow.png
// module id = XLVp
// module chunks = 3